var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.38462C3 3.48696 3.37928 2.62607 4.05442 1.99133C4.72955 1.35659 5.64522 1 6.6 1H9.2736C10.5852 1 11.9676 1.44338 13.266 2.11354C14.574 2.78821 15.8568 3.72462 16.9836 4.78513C18.1104 5.84564 19.104 7.04831 19.8204 8.27354C20.5296 9.48862 21 10.7793 21 12V19.6154C21 20.513 20.6207 21.3739 19.9456 22.0087C19.2705 22.6434 18.3548 23 17.4 23H6.6C5.64522 23 4.72955 22.6434 4.05442 22.0087C3.37928 21.3739 3 20.513 3 19.6154V4.38462ZM17.9772 8.65826C17.3353 7.68575 16.5745 6.78722 15.7104 5.98103C14.8506 5.16614 13.8921 4.44896 12.8544 3.84421C12.8848 4.02021 12.9 4.20034 12.9 4.38462V6.92308C12.9 7.37191 13.0896 7.80235 13.4272 8.11972C13.7648 8.43709 14.2226 8.61539 14.7 8.61539H17.4C17.5976 8.61539 17.79 8.62968 17.9772 8.65826Z",
    fill: "#2CBA88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.de3b6f2d49fdd346a7565f64523b256a.svg";
export { ForwardRef as ReactComponent };